import { AlertInfoIcon } from '@fortress-technology-solutions/fortress-component-library/Icons';
import { FormattedMessage } from 'react-intl';
import { CLAIM_TYPE_OPTIONS } from '../constants';

const normalizeHudClaimId = (value) => {
  return String(value || '')
    .trim()
    .toUpperCase();
};

export const getFormFields = (messages, intl, chargeCodeOptions) => [
  {
    variant: 'singleSelect',
    name: 'claimType',
    label: <FormattedMessage {...messages.claimTypeLabel} />,
    placeholder: intl.formatMessage(messages.claimTypePlaceholder),
    options: CLAIM_TYPE_OPTIONS,
    fullWidth: true,
    rules: {
      required: true,
    },
    GridProps: {
      xs: 12,
    },
  },
  {
    variant: 'text',
    name: 'hudClaimId',
    label: <FormattedMessage {...messages.claimIdLabel} />,
    InputLabelProps: {
      shrink: true,
      TooltipProps: {
        title: intl.formatMessage(messages.claimIdTooltip),
        placement: 'right',
        children: <AlertInfoIcon fontSize="small" />,
      },
    },
    inputProps: {
      maxLength: 14,
    },
    placeholder: intl.formatMessage(messages.claimIdPlaceholder),
    fullWidth: true,
    rules: {
      required: true,
      validate: (value) => {
        const normalized = normalizeHudClaimId(value);
        return (
          /^[A-Z0-9]{14}$/.test(normalized) ||
          intl.formatMessage(messages.claimIdError)
        );
      },
    },
    GridProps: {
      xs: 12,
    },
  },
  {
    variant: 'currency',
    name: 'requestedAmount',
    label: <FormattedMessage {...messages.requestedAmountLabel} />,
    fullWidth: true,
    rules: {
      required: true,
      min: 0.01,
      validate: (value) => {
        return (
          Number(value) > 0 || intl.formatMessage(messages.requestedAmountError)
        );
      },
    },
    GridProps: {
      xs: 12,
    },
  },
  {
    variant: 'singleSelect',
    name: 'propertyTransactionCodeId',
    label: <FormattedMessage {...messages.chargeCodeLabel} />,
    InputLabelProps: {
      shrink: true,
      TooltipProps: {
        title: intl.formatMessage(messages.chargeCodeTooltip),
        placement: 'right',
        children: <AlertInfoIcon fontSize="small" />,
      },
    },
    placeholder: intl.formatMessage(messages.chargeCodePlaceholder),
    options: chargeCodeOptions,
    fullWidth: true,
    rules: {
      required: true,
    },
    GridProps: {
      xs: 12,
    },
  },
];
